import JsonTagField from '@/libs/fieldModule/module/jsonTagField'
import moduleHelper from '../../moduleHelper'

export default moduleHelper(JsonTagField)
